import { Timestamp } from '@firebase/firestore/lite';


export function getAge(birthdate: Timestamp) {
  return new Date(+new Date - +birthdate.toDate()).getUTCFullYear() - 1970;
}
